<template>
  <footer class="py-4 bg-[#191b26]">
    <div class="container mx-auto px-4 text-xs md:text-sm ">
      <p class="text-center text-white">EXPO RURAL 2026</p>
      <p class="text-center text-white">© 2026 Todos los derechos reservados. La Rural</p>
      <p class="text-center text-white text-xs">Desarrollado por <a href="https://www.qreventos.com" target="_blank" class="hover:underline">QREventos.com</a></p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
    methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>